import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App.js";
import { noteArrival } from "./arrival.js";
import { TestServerBanner } from "./ui/testServer.js";
import { UpdatingBanner, watchForUpdates } from "./ui/updating.js";
import { makeQueryClient } from "./ui/queryClient.js";
import "./styles.css";

// Before the first render, because the referrer is a fact about this page load and nothing else will ever have it
// again (`arrival.ts`). It writes nothing to the server and asks nothing; it remembers one host.
noteArrival();
// Which build this tab is, so that after an update it can tell whether a reload would bring anything new.
watchForUpdates();

const qc = makeQueryClient({ queries: { retry: 1, refetchOnWindowFocus: false } });
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <App />
      {/* Beside the app rather than inside it, so every screen shows it, sign-in included (ADR 0020). */}
      <TestServerBanner />
      <UpdatingBanner />
    </QueryClientProvider>
  </StrictMode>,
);
